function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M0 83.923h512v341.326H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M512 108.546L59.699 258.293 512 408.038v20.039L0 258.293 512 88.508z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M512 374.201v33.837L59.699 258.293 512 108.546v33.838"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M493.301 253.493h-29.275c7.612-9.139 7.141-22.736-1.432-31.31 9.084-9.082 9.084-23.81 0-32.895l-.546.549c9.082-9.082 9.63-24.359.546-33.441L331.019 287.971c9.084 9.085 23.552 8.976 32.634-.108l2.532-2.314 63.003-5.728v27.097h21.37v-29.04l32.056-2.913 10.687-21.472z",
  fill: "#a2001d"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M333.03 316.084l-21.378-10.685 21.378-10.685h138.908v21.37z"
});

const SvgAmericanSamoa = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAmericanSamoa, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/american-samoa.c7b5a861.svg";
export { ForwardRef as ReactComponent };